import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from '@emotion/react';
import { Colors, ColorsCSS } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { TypographyPDL, TypographyCustomPropertyMap } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("Text", {
  root: (props) => [
    TypographyPDL(TypographyCustomPropertyMap[props.type], props.type),
    props.color === "neutral800" ? {
      color: `var(--zds-text-default, ${Colors.neutral800})`
    } : {
      color: ColorsCSS[props.color]
    },
    props.fontWeight && {
      fontWeight: props.fontWeight
    },
    {
      margin: props.margin,
      maxWidth: "100%",
      textAlign: props.textAlign
    },
    props.hasTransition && {
      transition: "color 0.2s ease-in-out"
    }
  ]
});
const Text = (_a) => {
  var { className, color = "neutral800", hasTransition = true, tag = "span", textAlign = "inherit", type = "paragraph3" } = _a, otherProps = __rest(_a, ["className", "color", "hasTransition", "tag", "textAlign", "type"]);
  const props = Object.assign({
    color,
    hasTransition,
    tag,
    textAlign,
    type
  }, otherProps);
  return jsx(props.tag, { className, css: Styles.root(props), "data-zds": true }, props.children);
};

export { Text };
//# sourceMappingURL=Text.es.js.map
